import { PORTAL_UI_V2 } from "../config/uiTheme";
import CreateSiteLegacy from "./forms/CreateSiteLegacy";
import CreateSiteV2 from "./forms/CreateSiteV2";

const CreateSite = () => (PORTAL_UI_V2 ? <CreateSiteV2 /> : <CreateSiteLegacy />);

export default CreateSite;
